export enum SavingIndicatorState {
  INITIAL = 'initial',
  SAVING = 'saving',
  SAVED = 'saved',
  ERROR = 'error',
}
